import { createDefaultTyrann } from '@apis/common';
import { seaWaybillLog } from '@models/SeaWaybill';
import * as t from 'io-ts';

export const seaWaybillLogApis = createDefaultTyrann({
  '/dashboard/sea-waybill-log/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: seaWaybillLog,
      },
    },
  },
  '/sea-waybill-log/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: seaWaybillLog,
      },
    },
  },
});
